import {AgentIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {useCallback} from 'react'
import {useClickAnalytics} from '@github-ui/use-analytics'

export interface CopilotAssignmentButtonProps {
  onClick: () => void
  ref?: React.Ref<HTMLButtonElement>
}

export const CopilotAssignmentButton = ({ref, onClick}: CopilotAssignmentButtonProps) => {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  const handleClick = useCallback(() => {
    sendClickAnalyticsEvent({
      category: 'copilot_assignment',
      action: 'click_assign_to_copilot_button',
      label: 'ref_cta:assign_to_copilot',
    })
    onClick()
  }, [sendClickAnalyticsEvent, onClick])

  const label = 'Assign to Agent'

  return (
    <Button ref={ref} leadingVisual={AgentIcon} size="small" block onClick={handleClick}>
      {label}
    </Button>
  )
}

CopilotAssignmentButton.displayName = 'CopilotAssignmentButton'
